import React, { useReducer, ReactNode } from 'react';

import { globalReducer, initialState } from './globalReducer';
import { GlobalContext } from './GlobalContext';

export const GlobalContextProvider = (props: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(globalReducer, initialState);

  return (
    <GlobalContext.Provider value={{ ...state, dispatch }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
